import type { RoleEnum } from '@bambi/api-client/schemas';

export const rolesThatCanCreateTripsInThePast: RoleEnum[] = [
  'admin',
  'owner',
  'bambi',
];
